import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";

import AuthPage from "@/pages/AuthPage";
import AuthCallback from "@/pages/AuthCallback";
import NewHome from "@/pages/NewHome";
import Activity from "@/pages/Activity";
import Notifications from "@/pages/Notifications";
import SearchPage from "@/pages/SearchPage";
import LocationSelector from "@/pages/LocationSelector";
import MapView from "@/pages/MapView";
import CreatePost from "@/pages/CreatePost";
import PostDetail from "@/pages/PostDetail";
import Profile from "@/pages/Profile";
import Messages from "@/pages/Messages";

import "@/App.css";

/* 🔐 Private Route Wrapper */
function PrivateRoute({ children }) {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/auth" replace />;
}

/* 🧭 Router Logic */
function AppRouter() {
  const location = useLocation();
  const navigate = useNavigate();

  // ✅ Hooks ALWAYS run first (no early return)
  useEffect(() => {
    // 🔐 Google OAuth callback (hash-based)
    if (location.hash && location.hash.includes("session_id=")) {
      navigate("/auth/callback", { replace: true });
      return;
    }

    // 🚫 Prevent access to auth when logged in
    const token = localStorage.getItem("token");
    if (
      token &&
      (location.pathname === "/" || location.pathname === "/auth")
    ) {
      navigate("/home", { replace: true });
    }
  }, [location, navigate]);

  return (
    <Routes>
      {/* 🌐 Public routes */}
      <Route path="/" element={<AuthPage />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/auth/callback" element={<AuthCallback />} />

      {/* 🔒 Protected routes */}
      <Route path="/home" element={<PrivateRoute><NewHome /></PrivateRoute>} />
      <Route path="/activity" element={<PrivateRoute><Activity /></PrivateRoute>} />
      <Route path="/notifications" element={<PrivateRoute><Notifications /></PrivateRoute>} />
      <Route path="/search" element={<PrivateRoute><SearchPage /></PrivateRoute>} />
      <Route path="/location-selector" element={<PrivateRoute><LocationSelector /></PrivateRoute>} />
      <Route path="/map-view" element={<PrivateRoute><MapView /></PrivateRoute>} />
      <Route path="/create-post" element={<PrivateRoute><CreatePost /></PrivateRoute>} />
      <Route path="/post/:postId" element={<PrivateRoute><PostDetail /></PrivateRoute>} />
      <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
      <Route path="/messages" element={<PrivateRoute><Messages /></PrivateRoute>} />

      {/* 🔁 Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

/* 🚀 App Entry */
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
